import { Typography } from 'seagull';
import ExternalLinkButton from "../../../../../components/ExternalLinkButton";
import { useFeatureFlags } from "../../../../../hooks/useFeatureFlags";
import { helpArticles } from "../../../../../utils/helpArticles";
import { CompleteKYCIcon } from "../../BusinessOnboardingWidget.icons";
import { StepLayout, StepHelperText, ActionButton } from "../../BusinessOnboardingWidget.utils";
import styles from "./CompleteKYC.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function CompleteKYCAction(props) {
  const {
    KYB_VERIFICATION
  } = useFeatureFlags();
  return /*#__PURE__*/_jsx(StepLayout, {
    id: "kyc",
    title: 'Complete Know Your Business Verification',
    subtitle: /*#__PURE__*/_jsxs(Typography, {
      children: ['Anchor is legally required to verify your business and associated individuals before you can start receiving payments. ', /*#__PURE__*/_jsx(ExternalLinkButton, {
        openInNewTab: true,
        underline: "none",
        href: helpArticles.kybProcessOverview(),
        children: "Read more"
      })]
    }),
    actions: /*#__PURE__*/_jsxs("div", {
      className: styles.actionsWrapper,
      children: [/*#__PURE__*/_jsx(ActionButton, {
        "data-testid": "onboarding-widget-complete-kyc",
        onClick: props.startKyc,
        children: "Complete KYB"
      }), /*#__PURE__*/_jsx(StepHelperText, {
        dataTestId: "onboarding-widget-complete-kyc-helper-text",
        children: KYB_VERIFICATION ? 'Verification is usually completed within minutes and may take longer if additional information is required.' : '* Verification process takes several minutes up to three business days.'
      })]
    }),
    icon: /*#__PURE__*/_jsx(CompleteKYCIcon, {})
  });
}
function KYCUnderReview() {
  const {
    KYB_VERIFICATION
  } = useFeatureFlags();
  return /*#__PURE__*/_jsx(StepLayout, {
    id: "kyc",
    title: "You've successfully submitted your KYB information",
    subtitle: "You will be notified if additional information is needed.",
    actions: /*#__PURE__*/_jsx("div", {
      "data-testid": "onboarding-widget-under-review",
      className: styles.actionsWrapper,
      children: /*#__PURE__*/_jsx(StepHelperText, {
        children: KYB_VERIFICATION ? 'Verification is usually completed within minutes and may take longer if additional information is required.' : '* Verification process takes several minutes up to three business days.'
      })
    }),
    icon: /*#__PURE__*/_jsx(CompleteKYCIcon, {})
  });
}
function KYCCompleted() {
  return /*#__PURE__*/_jsx(StepLayout, {
    id: "kyc",
    title: "You've successfully completed the KYB process",
    subtitle: 'Payments can now be transferred to your account',
    actions: null,
    icon: /*#__PURE__*/_jsx(CompleteKYCIcon, {})
  });
}
export default function CompleteKYC(props) {
  const {
    isComplete,
    extraProps
  } = props;
  const {
    startKyc,
    isUnderReview
  } = extraProps;
  if (isComplete) {
    return /*#__PURE__*/_jsx(KYCCompleted, {});
  } else if (isUnderReview) {
    return /*#__PURE__*/_jsx(KYCUnderReview, {});
  } else {
    return /*#__PURE__*/_jsx(CompleteKYCAction, {
      startKyc: startKyc
    });
  }
}